import { formatPhone, stripCountryCode } from '@agendor/ui';

// Clients sign in by phone; an e-mail is only what older clients signed in with.
export default function getClientContactInfo(client: { phoneNumber: string | null; email: string | null }): {
    label: string;
    value: string;
} {
    if (client.phoneNumber) return { label: 'WhatsApp', value: formatPhone(stripCountryCode(client.phoneNumber)) };
    if (client.email) return { label: 'E-mail', value: client.email };
    return { label: 'WhatsApp', value: '-' };
}
